import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { People } from './pages/People';
import { Research } from './pages/Research';
import { Equipment } from './pages/Equipment';
import { Publications } from './pages/Publications';
import { Projects } from './pages/Projects';
import { CollaboratorsPage } from './pages/CollaboratorsPage';
import { Gallery } from './pages/Gallery';
import { Weather } from './pages/Weather';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/people" element={<People data-id="element-6" />} data-id="element-5" />
          <Route path="/research" element={<Research data-id="element-8" />} data-id="element-7" />
          <Route path="/equipment" element={<Equipment data-id="element-10" />} data-id="element-9" />
          <Route path="/publications" element={<Publications data-id="element-12" />} data-id="element-11" />
          <Route path="/projects" element={<Projects data-id="element-14" />} data-id="element-13" />
          <Route path="/collaborators" element={<CollaboratorsPage data-id="element-16" />} data-id="element-15" />
          <Route path="/gallery" element={<Gallery data-id="element-18" />} data-id="element-17" />
          <Route path="/weather" element={<Weather data-id="element-20" />} data-id="element-19" />
          <Route path="/contact" element={<ContactPage data-id="element-22" />} data-id="element-21" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}